"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetRequest$ = exports.GetLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetRequest$outboundSchema = exports.GetLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetRequest$inboundSchema = exports.GetLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetSecurity$ = exports.GetLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetSecurity$outboundSchema = exports.GetLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetSecurity$inboundSchema = void 0;
exports.getLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetSecurityToJSON = getLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetSecurityToJSON;
exports.getLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetSecurityFromJSON = getLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetSecurityFromJSON;
exports.getLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetRequestToJSON = getLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetRequestToJSON;
exports.getLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetRequestFromJSON = getLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetRequestFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.GetLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetSecurity$inboundSchema = z.object({
    Bearer: z.string().optional(),
    "X-API-KEY": z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "Bearer": "bearer",
        "X-API-KEY": "xApiKey",
    });
});
/** @internal */
exports.GetLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetSecurity$outboundSchema = z.object({
    bearer: z.string().optional(),
    xApiKey: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        bearer: "Bearer",
        xApiKey: "X-API-KEY",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetSecurity$;
(function (GetLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetSecurity$) {
    /** @deprecated use `GetLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetSecurity$inboundSchema` instead. */
    GetLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetSecurity$.inboundSchema = exports.GetLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetSecurity$inboundSchema;
    /** @deprecated use `GetLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetSecurity$outboundSchema` instead. */
    GetLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetSecurity$.outboundSchema = exports.GetLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetSecurity$outboundSchema;
})(GetLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetSecurity$ || (exports.GetLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetSecurity$ = GetLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetSecurity$ = {}));
function getLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetSecurityToJSON(getLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetSecurity) {
    return JSON.stringify(exports.GetLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetSecurity$outboundSchema
        .parse(getLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetSecurity));
}
function getLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetSecurityFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetSecurity$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'GetLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetSecurity' from JSON`);
}
/** @internal */
exports.GetLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetRequest$inboundSchema = z.object({
    "filter[end_date]": z.string().optional(),
    "filter[start_date]": z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "filter[end_date]": "filterEndDate",
        "filter[start_date]": "filterStartDate",
    });
});
/** @internal */
exports.GetLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetRequest$outboundSchema = z.object({
    filterEndDate: z.string().optional(),
    filterStartDate: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        filterEndDate: "filter[end_date]",
        filterStartDate: "filter[start_date]",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetRequest$;
(function (GetLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetRequest$) {
    /** @deprecated use `GetLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetRequest$inboundSchema` instead. */
    GetLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetRequest$.inboundSchema = exports.GetLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetRequest$inboundSchema;
    /** @deprecated use `GetLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetRequest$outboundSchema` instead. */
    GetLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetRequest$.outboundSchema = exports.GetLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetRequest$outboundSchema;
})(GetLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetRequest$ || (exports.GetLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetRequest$ = GetLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetRequest$ = {}));
function getLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetRequestToJSON(getLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetRequest) {
    return JSON.stringify(exports.GetLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetRequest$outboundSchema
        .parse(getLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetRequest));
}
function getLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetRequestFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetRequest$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'GetLettingsNationalAverageListingPriceStatsLettingsNationalAverageListingPriceGetRequest' from JSON`);
}
//# sourceMappingURL=getlettingsnationalaveragelistingpricestatslettingsnationalaveragelistingpriceget.js.map